import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { PALETTE } from '../ThemeConstants'
import { useState } from 'react'

export default function AlertModal({color=PALETTE.MAINCOLOR, onConfirm, onCancel, getDataId, show, onHide, title, description}) {
  const [id, setId] = useState(-1)

  const retrieveId = () => {
      const dataId = getDataId()
      setId(dataId)
  }

  return (
    <Modal
      show={show}
      onShow={retrieveId}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {description}
      </Modal.Body>
      <Modal.Footer>
          <Button variant="secondary" onClick={onCancel}>
            Close
          </Button>
          <Button variant="danger" onClick={() => {onConfirm(id)}}>
            Delete
          </Button>
        </Modal.Footer>
    </Modal>
  )
}